import Config from 'config';
import { createAsyncThunk } from '@reduxjs/toolkit';
import QueryString from 'qs';
import { TAsyncThunkState } from '../../types';
import ApiaApi from '../../../../api/apiaApi/apiaApi';
import {
  TApiaFiltersConditionsDefinition,
  TApiaFinderFiltersConditionsElementDefinition,
} from '../../../../components/apia/execution/fields/apiaFinder/types';
import { arrayOrArray } from '../../../../utils/util';

export const getFiltersConditions = createAsyncThunk<
  {
    conditions: TApiaFinderFiltersConditionsElementDefinition[];
    action: string;
    title: string;
  } | null,
  { fieldId: string },
  TAsyncThunkState
>('querySlice/getFiltersConditions', async ({ fieldId }, thunkApi) => {
  const state = thunkApi.getState().querySlice.queries[fieldId];
  const url = Config.FINDER_GET_FILTERS_CONDITIONS(state.ajaxUrl);

  const response = await ApiaApi.post<TApiaFiltersConditionsDefinition>(url, {
    notificationsCategory: 'apiaFinder',
  });

  if (response && response.data) {
    const {
      data: {
        form: {
          action,
          title,
          elements: { element: conditions },
        },
      },
    } = response;

    return {
      conditions: arrayOrArray(conditions),
      action,
      title,
    };
  }

  return null;
});

export const setFiltersConditions = createAsyncThunk<
  boolean,
  { fieldId: string; payload: Record<string, string | number> },
  TAsyncThunkState
>('querySlice/setFiltersConditions', async ({ fieldId, payload }, thunkApi) => {
  const state = thunkApi.getState().querySlice.queries[fieldId];

  if (!state.setFilterTypesAction) return false;

  await ApiaApi.post(
    `${window.CONTEXT}${state.setFilterTypesAction}`,

    {
      notificationsCategory: 'apiaFinder',
      postData: QueryString.stringify({ ...payload, isAjax: true }),
    },
  );

  throw new Error();
});
